import { NoteList } from "components/notes";
import { useAbstractWorkItemContext, useAddWorkItemNote, useWorkItemNotes } from "hooks/work-items";
import { useUpdateNote } from "hooks/notes";
import { TraceVisit } from "components/shared/audit";
import styled from "@emotion/styled";
import { Box } from "@mui/material";

type WorkItemNotesProps = {
    draft?: boolean;
};

const FormTitle = styled(Box)({
    fontSize: '22px',
    marginBottom: '10px',
    fontWeight: 'bold'
});

const NotesContainer = styled(Box)({
    width: '60vw'
});


const WorkItemNotes = (props: WorkItemNotesProps) => {
    const workItemContext = useAbstractWorkItemContext();
    const { workItem } = workItemContext;
    const { draft } = props;

    const [
        notes,
        count,
        handleRefresh,
        loading,
        error
    ] = useWorkItemNotes(workItem?.id ?? 0, draft);

    const addWorkItemNote = useAddWorkItemNote(workItem?.id, handleRefresh, draft);
    const updateNote = useUpdateNote(handleRefresh);

    return (
        <>
            <TraceVisit description='Work Item Notes Tab' data={{
                workItemId: workItem?.id
            }} />
            {draft &&
                <FormTitle>
                    Notes
                </FormTitle>
            }
            <NotesContainer>
            <NoteList notes={notes} loading={loading}
                onRefresh={handleRefresh}
                onAdd={addWorkItemNote}
                onUpdate={updateNote}
                draft={draft}
            />
            </NotesContainer>
        </>
    );
};

export default WorkItemNotes;